import React, { Component } from "react";
import { RoutedViewProps } from "@my-dld/utils/UrlUtils";
import Strings from "@my-dld/assets/strings";
import EjariActionSuccessPage from "../EjariActionSuccessPage";
import { EjariContractContext, updateContractContext } from "@eres/ejari-core/contexts/EjariContractContext";
import { ContractFee, PayByTenantRequest } from "@eres/ejari-api/Entity/contract";
import { CurrencyUtil, LocaleUtil } from "@eres/core";
import { replaceNavigate } from "@my-dld/utils/StoreUtils";
import { trackEvent } from "@my-dld/utils/Analytics";
import { hideLoading, showLoading, showMessage } from "@my-dld/utils/UIUtils";
import { EjariApi } from "@eres/ejari-api";
import PayForContract from "../../../component/Contract/PayForContract";
import { UpdateProperty } from "@eres/ejari-core/actions";
import { getAppServices } from "@10x/coreapp/index";

interface Props extends RoutedViewProps<any> {

}


interface State {

}

class NewContractSuccess extends Component<Props, State> {
	static contextType = EjariContractContext;
	context!: React.ContextType<typeof EjariContractContext>;
	pay = React.createRef<PayForContract>();

	render() {
		const { newContract } = this.context;
		return <EjariActionSuccessPage
			message={ Strings.contract_added_successfully }
			title={ Strings.create_new_contract }
			hideButton={ true }
			buttonTitle={ Strings.home }
			refreshProperty={ true }
			extra={ <div className="refn-box">
				{ Strings.contract_number }: <span>{ newContract?.ContractNumber }</span>
			</div> }
			{ ...this.props }
		>
			<div className="alert alert-info">{ Strings.activate_by_paying_ejari_fee }</div>
			<Fees fees={ newContract?.Fees }/>
			<div className="fees-action">
				<div>
					<button
						className="btn btn_1 btn_style1" onClick={ this.sendToTenant }>
						{ Strings.send_to_tenant }
					</button>
					<span className="or-cap">{ Strings.or_caps }</span>
					<button
						className="btn btn_1 btn_style1" onClick={ this.payNow }>
						{ Strings.pay_now }
					</button>
				</div>
				<a
					href="#"
					onClick={ e => {
						e.preventDefault();
						replaceNavigate( "/mydld" );
					} }
					className="btn btn-grey btn_style1">{ Strings.home }</a>
			</div>
			<PayForContract contractNumber={ newContract?.ContractNumber! } ref={ this.pay }/>
		</EjariActionSuccessPage>;
	}

	sendToTenant = () => {
		trackEvent( "EjariContract", "PaymentByTenant" );
		showLoading();
		const { newContract: contract } = this.context;
		let req: PayByTenantRequest = {
			email: contract?.TenantEmail!,
			mobile: contract?.TenantMobileNumber!,
			contractNumber: contract?.ContractNumber!,
		};
		EjariApi.requestPayByTenant( req )
		.then( ( response ) => {
				hideLoading();
				updateContractContext( { feePayMode: "tenant" } );
				replaceNavigate( "completed" );
			},
		).catch( ( reason ) => {
			hideLoading();
			showMessage( reason );
		} );
	};
	payNow = () => {
		this.pay.current?.initPayment( ( isSuccess, data ) => {
			if ( isSuccess ) {
				UpdateProperty( getAppServices().storeService.getStore() );
				updateContractContext( { feePayMode: "paid" } );
				replaceNavigate( "completed" );
			}
		} );
	};
}

interface FeeProps {
	fees?: ContractFee[];
}

function Fees( props: FeeProps ) {
	const { fees } = props;
	if ( fees == null ) return null;
	const total = fees.reduce( ( previousValue, currentValue ) => previousValue + Number( currentValue.Amount ), 0 );
	return <div className="ejari-fees align-self-center ">
		<ul className="list-group mydld-service-charge">
			<li className="list-group-item mydld-service-charge-title">
				<span>{ Strings.fee_details }</span>
			</li>
			{ fees.map( ( value, index ) => {
				return <li className="list-group-item" key={ index }>
					<span>{ LocaleUtil.getLocalValue( { en: value.FeeNameEn, ar: value.FeeNameAr } ) }</span>
					<span>{ CurrencyUtil.toFormattedCurrency( value.Amount! ) + " " + Strings.aed }</span>
				</li>;
			} ) }
			<li className="list-group-item mydld-service-charge-title">
				<span>{ Strings.total }</span>
				<span>{ CurrencyUtil.toFormattedCurrency( total ) + " " + Strings.aed }</span>
			</li>
		</ul>
	</div>;
}


export default NewContractSuccess;
